function initialState() {
  return {
    message: {
      countDown: 0,
      display: false,
      icon: undefined,
      seconds: 5,
      status: undefined,
      text: undefined,
      button: undefined,
      classes: '',
      dismissClick: () => {},
      ignoreBeforeTransition: false,
    },
    notifications: {
      trialExpired: undefined,
      terms: undefined,
    },
  }
}

const state = initialState()

const getters = {
  message: state => state.message,
  trialExpired: state => state.notifications.trialExpired,
  terms: state => state.notifications.terms,
}

const actions = {}

const mutations = {
  updateCountDown() {
    state.message.countDown--
  },

  clearCountDown() {
    state.message.countDown = 0
  },

  show(state, message) {
    state.message = initialState().message
    state.message = {
      ...state.message,
      ...message,
      countDown: initialState().message.seconds,
    }
  },

  display(state, message) {
    state.message = initialState().message
    state.message = {
      ...state.message,
      ...message,
      icon: messageIcons[message.icon],
      display: true,
    }
  },
  setTrialExpired(state, trialExpired) {
    state.notifications.trialExpired = trialExpired
  },

  hideOnBeforeDestroy() {
    if (!state.message.ignoreBeforeTransition) {
      state.message = initialState().message
    }
  },

  hide(state) {
    state.message = initialState().message
  },

  setTerms(state, terms) {
    state.notifications.terms = terms
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}

const messageIcons = {
  group: '/messages/icon_group.svg',
  network: '/messages/icon_network.svg',
}
